// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1bsb1osq{width:100%}\n._1h1tn7od{aspect-ratio:unset}\n._4t3i1osq{height:100%}\n._5ral1dfr{object-fit:cover}", ""]);
// Exports
module.exports = exports;
